export default __webpack_public_path__ + "static/media/user_guide_home_header.c4b3fb8e.png";